// extracted by mini-css-extract-plugin
export var wrapper = "not-found-module--wrapper--I9+cW";